import $ from 'jquery';

$.fn.formRange2 = function () {
    this.each(function () {
        const $container = $(this);
        const $radios = $container.find('input[type=radio]');
        const $slider = $('<input>', {
            type: 'range',
            class: 'form-range',
            min: 1,
            max: $radios.length - 1,
            tabIndex: -1,
            value: Math.max($radios.index($radios.filter(':checked')[0]), 1),
            disabled: $radios.prop('disabled'),
        }).prependTo($container);

        if ($radios.first().is(':checked')) {
            $container.addClass('is-blank');
        }

        $radios.on({
            focus: function () {
                $container.addClass('has-focus');
            },
            blur: function () {
                $container.removeClass('has-focus');
            },
            change: function () {
                const value = $radios.index(this);

                $slider.val(Math.max(value, 1));
                $container.toggleClass('is-blank', ! value);
            },
        });

        $slider.on({
            focus: function () {
                $container.removeClass('is-blank');
            },
            click: function () {
                const $radio = $radios.eq(Number($slider.val()));

                $radio.trigger('focus');

                if (! $radio.prop('checked')) {
                    $radio.prop('checked', true).trigger('change');
                }
            },
        });
    });
};

$(function () {
   $('.form-range2').formRange2();
});
